import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function postcodeValidator(): ValidatorFn {
  //this one accepts spaces to support autofill from the postcode search
  	const postcodeValidator = new RegExp(
		'^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$'
	);

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    return postcodeValidator.test(control.value) ? null : { postcode: true };
  };
}